export const isRelationshipField = fieldName => fieldName.endsWith('_id');



// WEBPACK FOOTER //
// ./src/relationships.js